import React from 'react';
import { useHistory } from 'react-router-dom';
import './Header.scss';
import { HeaderRight } from '../HeaderRight';
import { HeaderMobileMenu } from '../HeaderMobileMenu';
import Headroom from 'react-headroom';
import useSession from '../../../hooks/useSession';
import { AuthApi } from '../../../lib/api';
import { useAtom } from 'jotai';
import { bgColorAtom } from 'lib/common/atoms';

const Header = () => {
  const history = useHistory();
  const { isSession, logout } = useSession();
  const [bgColor] = useAtom(bgColorAtom);

  const onClickLogout = async () => {
    try {
      const authInfo = await AuthApi.delete('/sessions', {
        withCredentials: true,
      });

      if (authInfo.data.status_code === 200) {
        logout();
        history.go(0);
      }
    } catch (error) {
      logout();
      history.go(0);
    }
  };

  const onClickGoToPath = (path: string) => {
    const { pathname } = history.location;
    if (pathname === path) return;

    history.push(path);
  };

  return (
    <Headroom>
      <div className='Header' style={{ backgroundColor: bgColor }}>
        <div className='header-wrap'>
          <div className='logo'>
            <img
              className='school-logo'
              alt='로고'
              src={'/images/header/logo.png'}
              onClick={() => onClickGoToPath('/')}
            />
          </div>
          <div className='nav'>
            <ul>
              <li onClick={() => onClickGoToPath('/intro')}>
                <label>GENIVRWARE</label>
              </li>
              <li onClick={() => onClickGoToPath('/community/share-map')}>
                <label>SHARED MAPS</label>
              </li>
              <li onClick={() => onClickGoToPath('/download')}>
                <label>DOWNLOAD</label>
              </li>
              <li onClick={() => onClickGoToPath('/manual')}>
                <label>MANUAL</label>
              </li>
            </ul>
          </div>
          <HeaderRight isSession={isSession} onClickLogout={onClickLogout} />
          <HeaderMobileMenu onClickGoToPath={onClickGoToPath} isSession={isSession} onClickLogout={onClickLogout} />
        </div>
      </div>
    </Headroom>
  );
};

export default Header;
